import { Injectable } from '@angular/core';
import { Login } from '../entidade/login/login';
import { GlobalService } from './global.service';
import { GrupoArquivoTransparencia } from '../entidade/contabil/grupo-arquivo-transparencia.model';
import { TransparenciaInformacaoAdicionalGrupo } from '../entidade/contabil/transparencia-informacao-adicional-grupo.model';
import { TransparenciaTituloDescricaoQuadro } from '../entidade/contabil/titulo-descricao-quadro-transparencia.model';

export interface RotaTransparencia {
    pagina: string;
    rota: string;
    descricao?: string;
    externo?: boolean;
}

interface RotaTituloDescricaoQuadro {
    titulo: keyof TransparenciaTituloDescricaoQuadro;
    descricao: keyof TransparenciaTituloDescricaoQuadro;
    rota: string;
}

@Injectable({
    providedIn: 'root'
})
export class MapaRotasTransparenciaService {

    buscarRotaTransparencia(
        titulos?: TransparenciaTituloDescricaoQuadro,
        gruposArquivo?: GrupoArquivoTransparencia[],
        informacoesAdicionais?: TransparenciaInformacaoAdicionalGrupo[]
    ): RotaTransparencia[] {
        const login: Login = GlobalService.obterSessaoLogin();
        const ano = login && login.exercicio ? login.exercicio.ano : new Date().getFullYear();
        const orgaoId = login && login.orgao ? login.orgao.id : 1;
        const lista: RotaTransparencia[] = [];

        lista.push({ pagina: 'PARÂMETROS', rota: 'admin/transparencia/parametros-transparencia' });
        lista.push({ pagina: 'DECRETO', rota: 'transparencia/decreto' });
        lista.push({ pagina: 'PLANO PLURIANUAL (PPA)', rota: 'transparencia/planejamento' });
        lista.push({ pagina: 'RECEITA PREVISTA', descricao: 'É a primeira fase da arrecadação de recursos. As Receitas do governo passam por uma previsão inicial e essa previsão é atualizada ao longo do ano para se ajudar às mudanças que ocorrem durante o período.', rota: `transparencia/receita-prevista/${ano}` });
        lista.push({ pagina: 'DESPESA PREVISTA', descricao: 'O cronograma de desembolso mensal que irá nortear o fluxo de pagamento e qual a proporção pagas das despesas do município, considerando o desenho mensal da arrecadação das receitas.', rota: `transparencia/despesa-prevista/${ano}` });
        lista.push({ pagina: 'RECEBIMENTOS COVID-19', descricao: 'Consulte as transferências efetuadas pelo estado e união ao município.', rota: 'transparencia/receitas-orcamentarias/pesquisa/covid/1' });
        lista.push({ pagina: 'DESPESAS REALIZADAS COVID-19', rota: 'transparencia/empenhos-orcamentarios/pesquisa/covid/1' });
        lista.push({ pagina: 'ARRECADAÇÃO DE IMPOSTOS', rota: 'transparencia/receitas-orcamentarias/pesquisa/impostos/1' });
        lista.push({ pagina: 'ARRECADAÇÃO MENSAL DE RECEITAS ORÇAMENTÁRIAS', rota: `transparencia/receitas-orcamentarias/arrecadacao-mensal/${ano}/transparencia` });
        lista.push({ pagina: 'DESPESAS ORÇAMENTÁRIAS MENSAIS', rota: `transparencia/despesa-nivel/${ano}/transparencia` });
        lista.push({ pagina: 'DESPESAS DE VIAGENS', rota: 'transparencia/empenhos-orcamentarios/pesquisa/viagens/1' });
        lista.push({ pagina: 'EQUIPAMENTOS E MATERIAL PERMANENTE', rota: 'transparencia/empenhos-orcamentarios/pesquisa/equipamentos/1' });
        lista.push({ pagina: 'TRANSFERÊNCIAS ESTADUAIS', rota: 'transparencia/receitas-orcamentarias/pesquisa/estaduais/1' });
        lista.push({ pagina: 'TRANSFERÊNCIAS FEDERAIS', rota: 'transparencia/receitas-orcamentarias/pesquisa/federais/1' });
        lista.push({ pagina: 'OPERAÇÕES DE CRÉDITO', rota: 'transparencia/receitas-orcamentarias/pesquisa/operacoes/1' });
        lista.push({ pagina: 'REPASSES TERCEIRO SETOR', rota: 'transparencia/empenhos-orcamentarios/pesquisa/repasses/1' });
        lista.push({ pagina: 'CONTAS PÚBLICAS', rota: 'transparencia/contas-publica' });
        lista.push({ pagina: 'ANEXAR ARQUIVOS POR GRUPO', rota: 'transparencia/transparencia-arquivos' });
        lista.push({ pagina: 'TÍTULOS E DESCRIÇÕES DOS QUADROS', rota: 'transparencia/transparencia-titulos-descricoes' });
        lista.push({ pagina: 'BALANÇOS', rota: 'transparencia/execucao-orcamentaria/balancetes-anuais' });
        lista.push({ pagina: 'RELATÓRIO RESUMIDO DA EXECUÇÃO ORÇAMENTÁRIA - RREO', rota: 'transparencia/rreo' });
        lista.push({ pagina: 'Anexos Lei nº 4.320/64 - LDO', rota: 'transparencia/ldo' });
        lista.push({ pagina: 'CONSULTA DE FORNECEDORES', rota: 'transparencia/fornecedores/pesquisa' });
        lista.push({ pagina: 'RECEITAS ORÇAMENTÁRIAS', rota: 'transparencia/receitas-orcamentarias/pesquisa/todos/0' });
        lista.push({ pagina: 'RECEITAS EXTRA ORÇAMENTÁRIAS', rota: 'transparencia/receitas-extra-orcamentarias/pesquisa/1' });
        lista.push({ pagina: 'DESPESAS EXTRA ORÇAMENTÁRIAS', rota: 'transparencia/despesas-extra-orcamentarias/pesquisa/1' });
        lista.push({ pagina: 'EMPENHOS ORÇAMENTÁRIOS', rota: 'transparencia/empenhos-orcamentarios/pesquisa/todos/1' });
        lista.push({ pagina: 'EMPENHOS DE RESTOS A PAGAR', rota: 'transparencia/empenhos-resto/pesquisa/todos/1' });
        lista.push({ pagina: 'LIQUIDAÇÕES ORÇAMENTÁRIAS', rota: 'transparencia/liquidacoes-orcamentarias/pesquisa/1' });
        lista.push({ pagina: 'LIQUIDAÇÕES RESTO A PAGAR', rota: 'transparencia/liquidacoes-restos/pesquisa/1' });
        lista.push({ pagina: 'PAGAMENTO ORÇAMENTÁRIO', rota: 'transparencia/pagamentos-orcamentarios/pesquisa/1' });
        lista.push({ pagina: 'PAGAMENTO EXTRA ORÇAMENTÁRIO', rota: 'transparencia/pagamentos-extras/pesquisa/1' });
        lista.push({ pagina: 'PAGAMENTO DE RESTOS A PAGAR', rota: 'transparencia/pagamentos-restos/pesquisa/1' });
        lista.push({ pagina: 'ATAS DE REGISTRO DE PREÇOS', rota: 'transparencia/atas-registro-precos/pesquisa/1' });
        lista.push({ pagina: 'PLANOS DE CONTRATAÇÃO ANUAL', rota: 'transparencia/plano-contratacao-anual/pesquisa/1' });
        lista.push({ pagina: 'EVENTOS (HOLERITE)', rota: 'admin/transparencia/eventos-holerite' });
        lista.push({ pagina: 'TRANSFERÊNCIAS BANCÁRIAS', rota: 'transparencia/entre-orgaos/pesquisa/1' });
        lista.push({ pagina: 'REMUNERAÇÃO SERVIDORES PÚBLICOS', rota: `transparencia/folha-pagamento/pesquisa/1/${orgaoId}/${ano}/TODAS` });
        lista.push({ pagina: 'CARGOS E SALÁRIOS', rota: 'transparencia/cargos/pesquisa/1' });
        lista.push({ pagina: 'CONTRATOS E ADITIVOS', rota: 'transparencia/contratos/pesquisa/1' });
        lista.push({ pagina: 'CONVÊNIOS', rota: 'transparencia/convenios/pesquisa/1' });
        lista.push({ pagina: 'LICITAÇÕES', rota: 'transparencia/licitacoes/pesquisa/1' });
        lista.push({ pagina: 'COMPRAS - (OF)', rota: 'transparencia/compras/pesquisa/1' });
        lista.push({ pagina: 'USUÁRIOS', rota: 'usuarios' });
        lista.push({ pagina: 'ORGÃOS PÚBLICOS', rota: 'orgaos' });

        lista.push({
            pagina: 'Lei de Diretrizes Orçamentárias - LDO',
            descricao: 'A Lei de Diretrizes Orçamentárias (LDO) é elaborada anualmente e tem como objetivo apontar as prioridades do governo para o próximo ano. Ela orienta a elaboração da Lei Orçamentária Anual, baseando-se no que foi estabelecido pelo Plano Plurianual.',
            rota: 'transparencia/ldo'
        });
        lista.push({
            pagina: 'Programas',
            descricao: 'Ao criar um programa é estabelecido uma meta inicial de utilização durante o ano. No final do exercício é preenchido o total utilizado e sua justificativa com esclarecimentos.',
            rota: 'transparencia/planejamento'
        });
        lista.push({
            pagina: 'Ações',
            descricao: 'Ao gerar uma ação é pré estabelecido uma meta inicial para ser utilizada durante o ano. No final do exercício é preenchido o total que foi utilizado e sua justificativa com esclarecimentos.',
            rota: 'transparencia/planejamento'
        });


        this.adicionarRotasTitulosDescricoes(lista, titulos, ano, orgaoId);
        this.adicionarRotasGruposArquivo(lista, gruposArquivo);
        this.adicionarRotasInformacoesAdicionais(lista, informacoesAdicionais);

        return this.removerDuplicados(lista);
    }

    filtrarRotas(lista: RotaTransparencia[], filtro: string): RotaTransparencia[] {
        const termo = this.normalizarTexto(filtro);

        if (!termo) {
            return lista;
        }

        return lista.filter(rota => {
            const pagina = this.normalizarTexto(rota.pagina);
            const descricao = this.normalizarTexto(rota.descricao);

            return pagina.indexOf(termo) > -1 || descricao.indexOf(termo) > -1;
        });
    }

    private adicionarRotasTitulosDescricoes(
        lista: RotaTransparencia[],
        titulos: TransparenciaTituloDescricaoQuadro,
        ano: number,
        orgaoId: number
    ): void {
        if (!titulos) {
            return;
        }

        const rotas: RotaTituloDescricaoQuadro[] = [
            { titulo: 'recebimento_covid_titulo', descricao: 'recebimento_covid_descricao', rota: 'transparencia/receitas-orcamentarias/pesquisa/covid/1' },
            { titulo: 'despesa_covid_titulo', descricao: 'despesa_covid_descricao', rota: 'transparencia/empenhos-orcamentarios/pesquisa/covid/1' },
            { titulo: 'arrecadacao_receita_diaria_titulo', descricao: 'arrecadacao_receita_diaria_descricao', rota: 'transparencia/receitas-orcamentarias/pesquisa/todos/0' },
            { titulo: 'recebimento_fonte_recurso_titulo', descricao: 'recebimento_fonte_recurso_descricao', rota: 'transparencia/receitas-orcamentarias/pesquisa/fonte-recurso/0' },
            { titulo: 'arrecadacao_imposto_titulo', descricao: 'arrecadacao_imposto_descricao', rota: 'transparencia/receitas-orcamentarias/pesquisa/impostos/1' },
            { titulo: 'arrecadacao_mensal_titulo', descricao: 'arrecadacao_mensal_descricao', rota: `transparencia/receitas-orcamentarias/arrecadacao-mensal/${ano}/transparencia` },
            { titulo: 'empenho_orcamentario_titulo', descricao: 'empenho_orcamentario_descricao', rota: 'transparencia/empenhos-orcamentarios/pesquisa/todos/1' },
            { titulo: 'despesa_empenhada_mensal_titulo', descricao: 'despesa_empenhada_mensal_descricao', rota: `transparencia/despesa-nivel/${ano}/transparencia` },
            { titulo: 'liquidacao_orcamentaria_titulo', descricao: 'liquidacao_orcamentaria_descricao', rota: 'transparencia/liquidacoes-orcamentarias/pesquisa/1' },
            { titulo: 'pagamento_orcamentario_titulo', descricao: 'pagamento_orcamentario_descricao', rota: 'transparencia/pagamentos-orcamentarios/pesquisa/1' },
            { titulo: 'transferencia_orgao_titulo', descricao: 'transferencia_orgao_descricao', rota: 'transparencia/entre-orgaos/pesquisa/1' },
            { titulo: 'transferencia_estadual_titulo', descricao: 'transferencia_estadual_descricao', rota: 'transparencia/receitas-orcamentarias/pesquisa/estaduais/1' },
            { titulo: 'transferencia_federal_titulo', descricao: 'transferencia_federal_descricao', rota: 'transparencia/receitas-orcamentarias/pesquisa/federais/1' },
            { titulo: 'recebimento_extra_titulo', descricao: 'recebimento_extra_descricao', rota: 'transparencia/receitas-extra-orcamentarias/pesquisa/1' },
            { titulo: 'despesa_extra_titulo', descricao: 'despesa_extra_descricao', rota: 'transparencia/despesas-extra-orcamentarias/pesquisa/1' },
            { titulo: 'despesa_fonte_recurso_titulo', descricao: 'despesa_fonte_recurso_descricao', rota: 'transparencia/empenhos-orcamentarios/pesquisa/fonte-recurso/1' },
            { titulo: 'empenho_restos_titulo', descricao: 'empenho_restos_descricao', rota: 'transparencia/empenhos-resto/pesquisa/todos/1' },
            { titulo: 'pagamento_extra_titulo', descricao: 'pagamento_extra_descricao', rota: 'transparencia/pagamentos-extras/pesquisa/1' },
            { titulo: 'liquidacao_restos_titulo', descricao: 'liquidacao_restos_descricao', rota: 'transparencia/liquidacoes-restos/pesquisa/1' },
            { titulo: 'pagamento_restos_titulo', descricao: 'pagamento_restos_descricao', rota: 'transparencia/pagamentos-restos/pesquisa/1' },
            { titulo: 'licitacao_titulo', descricao: 'licitacao_descricao', rota: 'transparencia/licitacoes/pesquisa/1' },
            { titulo: 'contrato_titulo', descricao: 'contrato_descricao', rota: 'transparencia/contratos/pesquisa/1' },
            { titulo: 'consulta_fornecedor_titulo', descricao: 'consulta_fornecedor_descricao', rota: 'transparencia/fornecedores/pesquisa' },
            { titulo: 'ata_registro_preco_titulo', descricao: 'ata_registro_preco_descricao', rota: 'transparencia/atas-registro-precos/pesquisa/1' },
            { titulo: 'fiscais_contrato_titulo', descricao: 'fiscais_contrato_descricao', rota: 'transparencia/fiscais-contratos/pesquisa/1' },
            { titulo: 'painel_obra_titulo', descricao: 'painel_obra_descricao', rota: 'transparencia/painel-obras/pesquisa/1' },
            { titulo: 'informacao_adicionais_titulo', descricao: 'informacao_adicionais_descricao', rota: 'transparencia/informacoes-adicionais' },
            { titulo: 'emenda_palamentar_titulo', descricao: 'emenda_palamentar_descricao', rota: 'transparencia/emenda-parlamentar/pesquisa/1' },
            { titulo: 'despesa_viagem_titulo', descricao: 'despesa_viagem_descricao', rota: 'transparencia/empenhos-orcamentarios/pesquisa/viagens/1' },
            { titulo: 'equipamento_material_permanente_titulo', descricao: 'equipamento_material_permanente_descricao', rota: 'transparencia/empenhos-orcamentarios/pesquisa/equipamentos/1' },
            { titulo: 'operacao_credito_titulo', descricao: 'operacao_credito_descricao', rota: 'transparencia/receitas-orcamentarias/pesquisa/operacoes/1' },
            { titulo: 'convenio_titulo', descricao: 'convenio_descricao', rota: 'transparencia/convenios/pesquisa/1' },
            { titulo: 'repasse_terceiro_setor_titulo', descricao: 'repasse_terceiro_setor_descricao', rota: 'transparencia/empenhos-orcamentarios/pesquisa/repasses/1' },
            { titulo: 'transferencia_institucional_privada_titulo', descricao: 'transferencia_institucional_privada_descricao', rota: 'transparencia/empenhos-orcamentarios/pesquisa/transf-privada/1' },
            { titulo: 'remuneracao_servidor_titulo', descricao: 'remuneracao_servidor_descricao', rota: `transparencia/folha-pagamento/pesquisa/1/${orgaoId}/${ano}/TODAS` },
            { titulo: 'cargo_salario_titulo', descricao: 'cargo_salario_descricao', rota: 'transparencia/cargos/pesquisa/1' },
            { titulo: 'servidor_publico_credito_titulo', descricao: 'servidor_publico_credito_descricao', rota: 'transparencia/servidores-cedidos/pesquisa/1' },
            { titulo: 'servidor_publico_afastado_titulo', descricao: 'servidor_publico_afastado_descricao', rota: 'transparencia/servidores-afastados/pesquisa/1' },
            { titulo: 'planejamento_orcamentario_titulo', descricao: 'planejamento_orcamentario_descricao', rota: 'transparencia/planejamento' },
            { titulo: 'conta_publica_titulo', descricao: 'conta_publica_descricao', rota: 'transparencia/contas-publica' },
            { titulo: 'ordem_cronologica_pagamento_titulo', descricao: 'ordem_cronologica_pagamento_descricao', rota: 'transparencia/ordem-cronologica' },
            { titulo: 'anexo1_titulo', descricao: 'anexo1_descricao', rota: 'transparencia/planejamento' },
            { titulo: 'anexo2_titulo', descricao: 'anexo2_descricao', rota: 'transparencia/planejamento' },
            { titulo: 'anexo3_titulo', descricao: 'anexo3_descricao', rota: 'transparencia/planejamento' },
            { titulo: 'tributo_arrecadado_titulo', descricao: 'tributo_arrecadado_descricao', rota: 'transparencia/receitas-orcamentarias/pesquisa/impostos/1' },
            { titulo: 'anexo_loa_titulo', descricao: 'anexo_loa_descricao', rota: 'transparencia/loa' },
            { titulo: 'execusao_orcamentaria_titulo', descricao: 'execusao_orcamentaria_descricao', rota: 'transparencia/execucao-orcamentaria/lrf' },
            { titulo: 'ordem_fornecimento_titulo', descricao: 'ordem_fornecimento_descricao', rota: 'transparencia/compras/pesquisa/1' },
            { titulo: 'balancete_mensal_titulo', descricao: 'balancete_mensal_descricao', rota: 'transparencia/execucao-orcamentaria/balancetes' },
            { titulo: 'balanco_titulo', descricao: 'balanco_descricao', rota: 'transparencia/execucao-orcamentaria/balancetes-anuais' },
            { titulo: 'anexo_ensino_titulo', descricao: 'anexo_ensino_descricao', rota: 'transparencia/quadros-ensino' },
            { titulo: 'anexo_saude_titulo', descricao: 'anexo_saude_descricao', rota: 'transparencia/quadros-saude' },
            { titulo: 'plano_contratacao_anual_titulo', descricao: 'plano_contratacao_anual_descricao', rota: 'transparencia/plano-contratacao-anual/pesquisa/1' },
            { titulo: 'dividas_fornecedor_titulo', descricao: 'dividas_fornecedor_descricao', rota: 'transparencia/dividas-fornecedores/pesquisa' }
        ];

        rotas.forEach(rota => this.adicionarRotaTituloDescricao(lista, titulos, rota));
    }

    private adicionarRotasGruposArquivo(
        lista: RotaTransparencia[],
        gruposArquivo: GrupoArquivoTransparencia[]
    ): void {
        if (!gruposArquivo || gruposArquivo.length === 0) {
            return;
        }

        gruposArquivo.forEach(grupo => {
            const pagina = this.converterTexto(grupo.nome);

            if (!pagina || !grupo.id) {
                return;
            }

            lista.push({
                pagina,
                rota: `transparencia/transparencia-arquivos-view/${grupo.id}`,
                descricao: this.converterTexto(grupo.descricao)
            });
        });
    }

    private adicionarRotasInformacoesAdicionais(
        lista: RotaTransparencia[],
        informacoesAdicionais: TransparenciaInformacaoAdicionalGrupo[]
    ): void {
        if (!informacoesAdicionais || informacoesAdicionais.length === 0) {
            return;
        }

        informacoesAdicionais.forEach(informacao => {
            const pagina = this.converterTexto(informacao.nome);

            if (!pagina) {
                return;
            }

            const link = this.converterTexto(informacao.link);
            const rota = link || 'transparencia/informacoes-adicionais';

            lista.push({
                pagina,
                rota,
                descricao: this.converterTexto(informacao.descricao),
                externo: this.ehLinkExterno(rota)
            });
        });
    }

    private adicionarRotaTituloDescricao(
        lista: RotaTransparencia[],
        titulos: TransparenciaTituloDescricaoQuadro,
        rotaTituloDescricao: RotaTituloDescricaoQuadro
    ): void {
        const pagina = this.converterTexto(titulos[rotaTituloDescricao.titulo]);

        if (!pagina) {
            return;
        }

        lista.push({
            pagina,
            rota: rotaTituloDescricao.rota,
            descricao: this.converterTexto(titulos[rotaTituloDescricao.descricao])
        });
    }

    private removerDuplicados(lista: RotaTransparencia[]): RotaTransparencia[] {
        const indices: { [key: string]: number } = {};
        const resultado: RotaTransparencia[] = [];

        lista.forEach(item => {
            const chave = `${this.normalizarTexto(item.pagina)}|${item.rota}`;
            const indice = indices[chave];

            if (indice !== undefined) {
                resultado[indice] = {
                    pagina: item.pagina,
                    rota: item.rota,
                    descricao: item.descricao || resultado[indice].descricao,
                    externo: item.externo || resultado[indice].externo
                };
                return;
            }

            indices[chave] = resultado.length;
            resultado.push(item);
        });

        return resultado;
    }

    private converterTexto(valor: any): string {
        if (valor === null || valor === undefined) {
            return '';
        }

        return valor.toString().trim();
    }

    private normalizarTexto(valor: any): string {
        return this.converterTexto(valor)
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toUpperCase();
    }

    private ehLinkExterno(valor: string): boolean {
        return /^https?:\/\//i.test(valor);
    }
}
